<!--GRADOS-->
<h1 class="d_subtitulo">{{grados_label}}</h1>
<div class="d_principalin">
    <span *ngFor="let item of grados_list" class="d_galeria_numero {{item.clase}}"
        (click)="item.action && item.action()">{{item.label}}</span>
</div>